"use strict";

require("./kiwiirccom");
require("./undernet");